import React, { Fragment, useRef } from 'react';
import PropTypes from 'prop-types';
import QRCode from 'qrcode.react';

import useComponentSize from '../../../../../../../../hooks/useComponentSize';
import { getAccountMarketingMaterialFlyerQrCodeValue } from '../AccountMarketingMaterialFlyerPrintTemplate/helpers';
import { CUSTOM_DESIGN_FACE_REC_OFF_JOIN_STEP_COPY } from '../../../constants';

const CUSTOM_DESIGN_TEMPLATE_INSTRUCTIONS_AREA = {
  left: '56.5%',
  top: '53%',
  width: '35.5%',
  height: '47.5%',
};

/**
 * Base font size as a fraction of the canvas width, so the copy scales with
 * the render resolution (the final snapshot is 2250x3300 at 300 DPI —
 * 0.024 ≈ 54px ≈ 13pt in print). Title/list sizes derive from it via em.
 */
const CUSTOM_DESIGN_BASE_FONT_RATIO = 0.024;

const propTypes = {
  albumFolder: PropTypes.shape({
    id: PropTypes.string.isRequired,
    face_recognition_disabled: PropTypes.bool,
    onboarding_type: PropTypes.string,
  }).isRequired,
  account: PropTypes.shape({
    id: PropTypes.string,
    username: PropTypes.string,
  }),
  customDesign: PropTypes.shape({
    id: PropTypes.string,
    marketing_material_asset: PropTypes.shape({
      id: PropTypes.string,
      asset_image: PropTypes.shape({
        url: PropTypes.string,
      }),
    }),
  }).isRequired,
};

const AccountMarketingMaterialCustomDesignTemplate = ({
  albumFolder,
  account,
  customDesign,
}) => {
  const templateRef = useRef(null);
  const { width } = useComponentSize(templateRef);

  const url = getAccountMarketingMaterialFlyerQrCodeValue({
    albumFolder,
    account,
  });

  return (
    <Fragment>
      <div
        className="marketing-material-custom-design-instructions"
        style={{
          ...CUSTOM_DESIGN_TEMPLATE_INSTRUCTIONS_AREA,
          fontSize: width
            ? Math.round(width * CUSTOM_DESIGN_BASE_FONT_RATIO)
            : undefined,
        }}
      >
        <p className="marketing-material-custom-design-instructions-title">
          How to receive your photo proofs:
        </p>
        <ol>
          <li>Scan the QR code with your camera.</li>
          {albumFolder.face_recognition_disabled ? (
            <li>
              {CUSTOM_DESIGN_FACE_REC_OFF_JOIN_STEP_COPY[
                albumFolder.onboarding_type
              ] ?? CUSTOM_DESIGN_FACE_REC_OFF_JOIN_STEP_COPY.DEFAULT}
            </li>
          ) : (
            <li>Snap a selfie to join the event.</li>
          )}
          <li>Your photos will be found and texted or emailed to you!</li>
        </ol>
        <div className="marketing-material-custom-design-qrcode">
          <QRCode renderAs="canvas" value={url} size={width * 0.22 || 500} />
        </div>
      </div>

      <img
        ref={templateRef}
        className="marketing-material-custom-design-background"
        src={customDesign?.marketing_material_asset?.asset_image?.url}
        alt=""
      />
    </Fragment>
  );
};

AccountMarketingMaterialCustomDesignTemplate.propTypes = propTypes;

export default AccountMarketingMaterialCustomDesignTemplate;
